import { endpoints } from '../api/endpoints';
import { queryKeys } from './queryKeys';
import { queryConfig } from './queryConfig';
import { createListQueryHook } from './queryFactory';

export const useHome = createListQueryHook({
  queryKey: queryKeys.home(),
  endpoint: endpoints.home,
  config: {
    staleTime: queryConfig.staleTime.short,
  },
});

